import React from 'react';
import { getEnviroment } from "../../../lib/utils.es6";
import { getUserFullname, getPartnerGuid, getAuthorizationToken } from '../../../lib/access.es6';


class PolicyV2 extends React.Component {


  render() {
    const source = "aspin";
    const environment = getEnviroment()
    const stagingBaseUrl = "https://ipp-om-uganda-gle.staging.aspin-inclusivity.com";
    const productionBaseUrl = "https://ipp-om-uganda-gle.inclusivity-aspin.com";
    const baseUrl = environment === "prod" ? productionBaseUrl : stagingBaseUrl;
    const bearerToken = getAuthorizationToken();
    const host_base_url = window.location.origin;

    const partner = getPartnerGuid();
    const created_by = getUserFullname();
    const policyNumber = this.props.params && this.props.params.policy_number;
    const iframeSrc = `${baseUrl}/?partner=${encodeURIComponent(partner)}&created_by=${encodeURIComponent(created_by)}&source=${encodeURIComponent(source)}&bearer_token=${encodeURIComponent(bearerToken)}&host_base_url=${encodeURIComponent(host_base_url)}&environment=${encodeURIComponent(environment)}${policyNumber ? `&mode=amend&policy_number=${encodeURIComponent(policyNumber)}` : ''}`;

    console.log('iframeSrc: ', iframeSrc)
    console.log('baseUrl: ', baseUrl);
    console.log('environment: ', environment);

    return (
      <>
        <section
          style={{
            background: "#FFFFFF",
            borderRadius: "8px",
            height: "auto",
            marginTop: "30px",
            marginBottom: "30px",
            width: "100%",
          }}
        >
          <iframe
            src={iframeSrc}
            width="100%"
            height="100%"
            style={{
              width: "100%",
              height: "calc(100vh - 100px)",
              border: "none",
            }}
            title="Insurance Quote"
          ></iframe>
        </section>
      </>
    );
  }
}
export default PolicyV2;